import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { AuthState } from "@okta/okta-auth-js";
import { AxiosResponse } from "axios";
import AddDocumentsPayload from "../../../models/API/requestModels/addDocuments.model";
import FileActions from "../../FileActions";
import toastMessages from "../../helpers/toastMessage";

async function addDocuments(
  data: AddDocumentsPayload,
  authState: AuthState | null
) {
  const fileActions = new FileActions();
  const transitDocuments = await fileActions.UploadFiles({
    files: data.transitDocuments,
    token: authState?.accessToken?.accessToken ?? "",
  });

  return axiosInstance.post(
    "/v1/orders/new-flow/add-document",
    {
      orderId: data.orderId,
      transitDocuments,
    },
    {
      headers: {
        Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
    }
  );
}

function useAddDocuments(
  authState: AuthState | null
): UseMutationResult<AxiosResponse<any, any>, any, any> {
  return useMutation({
    mutationKey: ["addDocuments"],
    mutationFn: (values) => addDocuments(values, authState),
    onError: (error) => {
      toastMessages.error(error?.message ?? "Failed to add documents");
    },
    onSuccess: () => {
      toastMessages.success("Document(s) added successfully");
    },
  });
}

export default useAddDocuments;
